import ScannerLanding from './ScannerLanding';

export default ScannerLanding;
